import abi from './abi/ScroogeFinance.json';

export const scroogeAbi = abi;

// Placeholder — заменить после деплоя через VITE_SCROOGE_ADDRESS или напрямую здесь
export const SCROOGE_ADDRESS =
  import.meta.env.VITE_SCROOGE_ADDRESS || '0x0000000000000000000000000000000000000000';

// Блок деплоя, с которого начинается history indexing. 0n = от генезиса (для testnet ок, для mainnet обязательно подставить реальный).
export const SCROOGE_DEPLOY_BLOCK = import.meta.env.VITE_SCROOGE_DEPLOY_BLOCK
  ? BigInt(import.meta.env.VITE_SCROOGE_DEPLOY_BLOCK)
  : 0n;

export const IS_DEPLOYED =
  SCROOGE_ADDRESS !== '0x0000000000000000000000000000000000000000';
